import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <>
      <Helmet><title>Sayfa bulunamadı — W.Sign</title><meta name="robots" content="noindex, nofollow" /></Helmet>
      <section className="container-page py-24 md:py-32 text-center">
        <p className="font-mono text-sm text-[var(--color-fg-dim)]">HTTP 404</p>
        <h1 className="mt-3 text-4xl md:text-5xl font-semibold">Sayfa bulunamadı</h1>
        <p className="mt-3 text-[var(--color-fg-muted)]">
          Aradığın sayfa burada değil. Aşağıdan ana sayfaya dönebilirsin.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/" className="btn-primary">Ana sayfa</Link>
          <Link to="/verify" className="btn-ghost">Doğrulayıcı</Link>
        </div>
      </section>
    </>
  )
}
